import { useTranslation } from "react-i18next";

interface RegisterScreenProps {
  authBusy: boolean;
  authEmail: string;
  authPassword: string;
  authError: string | null;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onGoogleClick: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onSwitchToSignIn: () => void;
  onCancel: () => void;
}

export function RegisterScreen({
  authBusy, authEmail, authPassword, authError,
  onEmailChange, onPasswordChange, onGoogleClick, onSubmit, onSwitchToSignIn, onCancel,
}: RegisterScreenProps) {
  const { t } = useTranslation();

  return (
    <main className="screen">
      <section className="panel auth-panel">
        <h1 className="auth-emoji">👶</h1>
        <h2 className="auth-title">{t("auth.registerTitle")}</h2>
        <p className="auth-subtitle">{t("auth.registerSubtitle")}</p>

        <button className="google-btn" onClick={onGoogleClick} disabled={authBusy}>
          {t("auth.signInGoogle")}
        </button>

        <div className="auth-divider"><span>{t("auth.orDivider")}</span></div>

        <form className="auth-form" onSubmit={onSubmit}>
          <input
            type="email"
            placeholder={t("auth.email")}
            value={authEmail}
            onChange={e => onEmailChange(e.target.value)}
            required
            autoComplete="email"
          />
          <input
            type="password"
            placeholder={t("auth.password")}
            value={authPassword}
            onChange={e => onPasswordChange(e.target.value)}
            required
            autoComplete="new-password"
          />
          {authError && <p className="auth-error">{authError}</p>}
          <button type="submit" className="primary-btn" disabled={authBusy}>
            {authBusy ? t("common.loading") : t("auth.createAccount")}
          </button>
        </form>

        <button type="button" className="auth-link-btn" onClick={onSwitchToSignIn}>
          {t("auth.alreadyHaveAccount")}
        </button>

        <button type="button" className="auth-link-btn auth-toggle-btn" onClick={onCancel}>
          {t("common.cancel")}
        </button>

        <a href="/about/" className="about-link-btn" style={{ display: 'block', textAlign: 'center' }}>
          {t("auth.whatIsBabyLog")}
        </a>
      </section>
    </main>
  );
}
